import React from 'react';

import { makeStyles, useTheme } from '@material-ui/styles';
import PropTypes from 'prop-types';

export const useStyles = makeStyles(theme => ({
  circle: {
    borderRadius: '50%',
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[1],
    width: 42,
    height: 42,
    '& img': {
      borderRadius: '50%',
      width: 42,
      height: 42,
    },
  },
  icon: { maxHeight: 72 },
  logoContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 4,
    overflow: 'hidden',
    width: '100%',
  },
  horizontal: {
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    gap: 8,
    overflow: 'hidden',
  },
  logo: { maxHeight: 42, maxWidth: '100%', objectFit: 'contain', flexShrink: 0 },
  displayName: {
    color: theme.palette.text.primary,
    margin: 0,
    fontSize: '1.2rem',
    fontWeight: 'bold',
    lineHeight: 1.4,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  subtitle: {
    color: theme.palette.text.secondary,
    margin: 0,
    fontSize: '0.65rem',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

function Logo(props) {
  const { displayName, src, type, subtitle, ...restProps } = props;

  const classes = useStyles();
  const theme = useTheme();

  if (type === 'circle')
    return (
      <div className={classes.circle}>
        <img alt="Eskolare" src={theme.assets.icon} {...props} />
      </div>
    );

  if (type === 'icon')
    return <img alt="Eskolare" src={theme.assets.icon} className={classes.icon} {...props} />;

  return (
    <div className={classes.logoContainer}>
      <div className={classes.horizontal}>
        <img
          alt={displayName || 'Eskolare'}
          src={src || theme.assets.logoHorizontal}
          className={classes.logo}
          {...restProps}
        />
        {!!displayName && !!src && <h2 className={classes.displayName}>{displayName}</h2>}
      </div>
      {!!subtitle && <p className={classes.subtitle}>{subtitle}</p>}
    </div>
  );
}

Logo.defaultProps = {
  type: 'horizontal',
};

Logo.propTypes = {
  /**
   * The image source
   */
  displayName: PropTypes.string,
  src: PropTypes.string,
  subtitle: PropTypes.string,
  type: PropTypes.oneOf(['horizontal', 'icon', 'circle']),
};

export default Logo;
